'use strict';

(function ($) {
    /**
     * Check if element is in viewport
     */
    $.fn.isInViewport = function () {
        var $this = $(this);
        var $window = $(window);
        var elementTop = $this.offset().top;
        var elementBottom = elementTop + $this.outerHeight();

        var viewportTop = $window.scrollTop();
        var viewportBottom = viewportTop + $window.height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };
}(jQuery));
